export const hubDashboardPalette = {
  modules: {
    orders: '#84a802',
    products: '#1976d2',
    customers: '#9c27b0',
    collaborators: '#0288d1',
    stocks: '#ed6c02',
    production: '#2e7d32',
    sellers: '#5c6bc0',
    financial: '#00897b',
    pricePolicies: '#6a1b9a',
    replacement: '#f57c00',
    services: '#455a64',
    boxes: '#795548',
    cubages: '#546e7a',
  },
  orderStatus: {
    open: '#84a802',
    processing: '#1976d2',
    billing: '#ed6c02',
    completed: '#2e7d32',
    canceled: '#d32f2f',
  },
} as const

export type HubDashboardModuleKey = keyof typeof hubDashboardPalette.modules
export type HubDashboardOrderStatusKey = keyof typeof hubDashboardPalette.orderStatus

export const hcpDashboardPalette = {
  team: '#1976d2',
  deadlines: '#ed6c02',
  operation: '#2e7d32',
  artFlow: '#9c27b0',
  sheetAssembly: '#2e7d32',
  production: '#f44336',
  logistics: '#ff9800',
  flowManagement: '#0288d1',
  badgeSoon: '#9e9e9e',
} as const
